export default ({ app, route }) => {
  const {
    gclid: keywordData,
    utm_partner: partner,
    utm_source: source1,
    utm_content: content1,
    utm_campaign: campaign1,
    utm_medium: medium1,

    my_source: source2,
    my_content: content2,
    my_campaign: campaign2,
    my_medium: medium2,
  } = route.query;

  const payload = {
    google: {
      keywordData,
    },
    affiliate: {
      partner,
      code: content1 || content2 || keywordData,
      campaign: campaign1 || campaign2,
      source: source1 || source2,
      optionalParam: medium1 || medium2,
    },
  };

  const maxAge = 259200;

  if (
    Object.values(payload.affiliate).some(val => val) ||
    Object.values(payload.google).some(val => val)
  ) {
    app.$cookies.set('affiliate', payload, { maxAge });
  }
};
